// src/components/main/produzione/assegnazioniGantt/AssegnazioniGanttTimeline.tsx

import React from "react";
import { DateTime } from "luxon";

import { Macchina } from "components/anagrafiche/anagraficheSlice";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import GanttHeader from "./GanttHeader";
import GanttMacchinaRow from "./GanttMacchinaRow";

// ============================================
// INTERFACES
// ============================================

interface AssegnazioniGanttTimelineProps {
    macchine: Macchina[];
    dataDa: DateTime;
    numeroSettimane: 1 | 2 | 3 | 4 | 6;
    ordineLavoroSelezionatoId?: number;
    onAssegnazioneClick: (ordineLavoroId: number) => void;
    onAssegnazioneDrop: (
        assegnazioneId: number,
        nuovaMacchinaId: number,
        nuovaDataDa: string,
        nuovaDataA: string
    ) => void;
    onAssegnazioneResize: (
        assegnazioneId: number,
        nuovaDataDa: string | null,
        nuovaDataA: string | null
    ) => void;
    onAssegnazioneDelete: (
        assegnazioneId: number,
    ) => void;
    onOrdineLavoroDrop: (
        ordineLavoroId: number,
        macchinaId: number,
        data: string
    ) => void;
}

// ============================================
// COMPONENT
// ============================================

const AssegnazioniGanttTimeline = ({
                                       macchine,
                                       dataDa,
                                       numeroSettimane,
                                       ordineLavoroSelezionatoId,
                                       onAssegnazioneClick,
                                       onAssegnazioneDrop,
                                       onAssegnazioneResize,
                                       onAssegnazioneDelete,
                                       onOrdineLavoroDrop,
                                   }: AssegnazioniGanttTimelineProps) => {
    const theme = useTheme();

    // ============================================
    // RENDER
    // ============================================

    if (macchine.length === 0) {
        return (
            <Box sx={{ textAlign: "center", py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                    Nessuna macchina disponibile per le tecniche selezionate
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 1,
                overflow: "auto",
                backgroundColor: theme.palette.background.paper,
            }}
        >
            {/* Header con giorni */}
            <GanttHeader
                dataDa={dataDa}
                numeroSettimane={numeroSettimane}
            />

            {/* Righe macchine */}
            <Box>
                {macchine.map((macchina) => (
                    <GanttMacchinaRow
                        key={macchina.id}
                        macchina={macchina}
                        dataDa={dataDa}
                        numeroSettimane={numeroSettimane}
                        ordineLavoroSelezionatoId={ordineLavoroSelezionatoId}
                        onAssegnazioneClick={onAssegnazioneClick}
                        onAssegnazioneDrop={onAssegnazioneDrop}
                        onAssegnazioneResize={onAssegnazioneResize}
                        onAssegnazioneDelete={onAssegnazioneDelete}
                        onOrdineLavoroDrop={onOrdineLavoroDrop}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default AssegnazioniGanttTimeline;